import Fade from '@smart-tv/components/fade/fade';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import { useAtomValue } from 'jotai';
import React, { memo } from 'react';
import clsx from 'clsx';
import { isSliderFocusedAtom } from './player-controls-scrubber-base';
import styles from './player-controls-scrubber.module.scss';

const MAX_VALUE = 100;
const FADE_TIMEOUT = 500;

interface Props {
  liveProgressPercentage: number;
}

export const PlayerControlsScrubberStartOverLiveIndicator = (props: Props) => {
  const { liveProgressPercentage } = props;
  const isSliderFocused = useAtomValue(isSliderFocusedAtom);

  return (
    <Fade
      in={!!liveProgressPercentage && liveProgressPercentage < MAX_VALUE}
      timeout={FADE_TIMEOUT}
      unmountOnExit
    >
      <div
        className={clsx(styles['player-controls-scrubber-start-over-live-indicator'], {
          [styles['player-controls-scrubber-start-over-live-indicator--focused']]: isSliderFocused
        })}
        style={{ left: `${liveProgressPercentage}%` }}
        data-testid={testIds.player.playerControls.liveMarker}
      >
        <Typography
          className={styles['player-controls-scrubber-start-over-live-indicator__live-text']}
          // typography-cascade-workaround: remove once Typography uses CSS modules
          style={{ fontWeight: 700, lineHeight: 'var(--live-indicator-line-height)' }}
        >
          Live
        </Typography>

        <span
          className={clsx(styles['player-controls-scrubber-start-over-live-indicator__line'], {
            [styles['player-controls-scrubber-start-over-live-indicator__line--focused']]: isSliderFocused
          })}
        />
      </div>
    </Fade>
  );
};

export default memo(PlayerControlsScrubberStartOverLiveIndicator);
